module.exports = __webpack_public_path__ + "img/logo.b97cf6a2.png";